import { render, staticRenderFns } from "./DeviceColour.vue?vue&type=template&id=7b87ad55"
import script from "./DeviceColour.vue?vue&type=script&lang=js"
export * from "./DeviceColour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports